export const LOGGED_IN = "loggedIn";
export const LOGIN_TOKEN = "loginToken";
export const SINGLE_SIGN_ON_RESPONSE = "singleSignOnResponse";
